import { requestAPI } from '../components/utilities/Utils';

export async function menu(token, admin = "") {
    const qstring = admin ? '?$Filter=menuAdmin' : '?$Filter=not(menuAdmin)';
    return requestAPI("_api/Menu/GetMenu", "GET", qstring, null, token, false);
}